// generalsSlice.ts
import { createSlice } from "@reduxjs/toolkit";

export const AUTORIZA_SLICE = "autoriza";

const generalsSlice = createSlice({
  name: "autoriza",
  initialState: {
    isOpenRejection: false,
    isOpenAprove: false,
  },
  reducers: {
    setIsOpenRejection: (state, action) => {
      state.isOpenRejection = action.payload;
    },
    setIsOpenAprove: (state, action) => {
      state.isOpenAprove = action.payload;
    },
  },
});

export const { setIsOpenRejection, setIsOpenAprove } = generalsSlice.actions;
export default generalsSlice.reducer;

// usa la misma clave para leer del store
export const getIsOpenRejection = (state) => state.autoriza?.isOpenRejection ?? false;
export const getIsOpenAprove = (state) => state.autoriza?.isOpenAprove ?? false;
